const rangesAndColors = {
	shopDensity: {
		ranges: [
			{ min: 0, max: 2, color: "#C2DCFF" },
			{ min: 2, max: 4, color: "#70AEFF" },
			{ min: 4, max: 6, color: "#338BFF" },
			{ min: 6, max: 8, color: "#0058CC" },
			{ min: 8, max: 10, color: "#00357A" }
		],
		SliderRange: { min: 0, max: 100 }
	}
};
const TRANSPARENT = "#FFFFFF11";

const getColor = (value, ranges) => {
	let FoundedRange = ranges.find(item => {
		return value >= item.min && value <= item.max;
	});
	return { FoundedRange };
};

const getShopDensityRange = ({ data }) => {
	let min = Number.MAX_SAFE_INTEGER;
	let max = Number.MIN_SAFE_INTEGER;
	for (let [, obj] of Object.entries(data)) {
		if (obj.shops_density < min) min = obj.shops_density;
		if (obj.shops_density > max) max = obj.shops_density;
	}
	return { min, max };
};

const shopDensityPolygons = ({ locations }) => {
	try {
		let WhiteSpacePolygons = {};
		for (let [ind, obj] of Object.entries(locations)) {
			let { shops_density, coordinates } = obj;
			coordinates = coordinates.map(item => {
				return { lat: item[1], lng: item[0] };
			});
			let fillColor = TRANSPARENT;
			let FilterValue = shops_density;
			let ranges = rangesAndColors.shopDensity.ranges;
			let { FoundedRange } = getColor(FilterValue, ranges);
			const { color } = FoundedRange;
			fillColor = color;

			let polygon = {
				id: `shopDensity-${ind}`,
				coordinates: coordinates,
				style: { fillColor, strokeColor: "#00000055", zIndex: 5 },
				showInfo: false,
				filterData: {
					value: FilterValue
				},
				data: {}
			};
			WhiteSpacePolygons[`shopDensity-${ind}`] = polygon;
		}

		return { polygons: WhiteSpacePolygons };
	} catch (e) {
		console.error(e);
		Error("Error While Building WhiteSpace Polygons");
	}
};

const getshopDensitySlider = ({ data }) => {
	let SliderRange = getShopDensityRange({ data });
	let { min, max } = SliderRange;
	return {
		min,
		max,
		sliderHandler: SliderRange,
		type: "shop_density"
	};
};

const shopDensityMap = { shopDensityPolygons, getshopDensitySlider };
export default shopDensityMap;
